<app-hero-swap></app-hero-swap>
<app-ecosystem-hub></app-ecosystem-hub>
<app-financial-terminal></app-financial-terminal>

@if (state.activeFeatureTab() === 'farms') {
  <app-farms-section></app-farms-section>
}
@if (state.activeFeatureTab() === 'staking') {
  <app-staking-section></app-staking-section>
}

<app-promos-trust></app-promos-trust>
